import { Button } from '@talentmesh/ui/components/button';
import { X } from 'lucide-react';
import { useMatch } from 'react-router';
import IdentifiedButtonActions from '../../IdentifiedList/IdentifiedButtonActions';
import ShortlistedButtonActions from '../../ShortlistedList/ShortlistedButtonActions';
import { useAiSearchProfilePopoutContext } from '../AiSearchProfilePopoutContext';
import RoutePath from '@/Routing/RoutePath';

const ProfileActions = () => {
    const { closeProfilePopout, selectedProfile } = useAiSearchProfilePopoutContext();
    const isIdentifiedAiSearch = !!useMatch(RoutePath.IdentifiedAiSearch);
    const isShortlistedAiSearch = !!useMatch(RoutePath.ShortlistedAiSearch);

    const currentProfileId = selectedProfile?.id;
    const selectedRowIds = currentProfileId ? [currentProfileId] : [];

    return (
        <div className="flex items-center justify-between">
            <div className="flex items-center gap-1.25">
                {isIdentifiedAiSearch && (
                    <IdentifiedButtonActions
                        singleSelectionMode
                        selectedRowIds={selectedRowIds}
                        closeDialogCallback={closeProfilePopout}
                    />
                )}
                {isShortlistedAiSearch && (
                    <ShortlistedButtonActions
                        inDialog
                        selectedRows={[selectedProfile!]}
                        closeDialogCallback={closeProfilePopout}
                    />
                )}
            </div>
            <Button size="icon" variant="ghost" onClick={closeProfilePopout} data-testid="CloseIcon">
                <X className="size-4" />
            </Button>
        </div>
    );
};

export default ProfileActions;
